import { themeVar } from "@config/theme/cssVar";

/** Outlined edit/delete action chrome — Figma-style (#3C82F6 edit, #FF6E4F delete). */
export const CARD_EDIT_ACTION_BTN_CLASS =
	"text-[color:var(--admin-action-edit)] hover:text-[color:var(--admin-action-edit)] hover:bg-[color:var(--admin-action-edit-surface)] p-2 rounded-full transition-colors";

export const CARD_DELETE_ACTION_BTN_CLASS =
	"!text-[color:var(--admin-danger)] hover:!text-[color:var(--admin-danger)] hover:bg-[color:var(--admin-status-danger-surface)] p-2 rounded-full transition-colors [&_.MuiSvgIcon-root]:text-[color:var(--admin-danger)]";

export const FAQ_EDIT_ACTION_BTN_CLASS =
	"p-2 text-[color:var(--admin-action-edit)] hover:bg-[color:var(--admin-action-edit-surface)] rounded transition-colors";

export const FAQ_DELETE_ACTION_BTN_CLASS =
	"p-2 text-[color:var(--admin-danger)] hover:bg-[color:var(--admin-status-danger-surface)] rounded transition-colors";

export const actionIconSx = {
	edit: { color: themeVar.actionEdit },
	delete: { color: themeVar.danger },
} as const;
